<div class="app-actions" *ngIf="actions.length > 0">
  <ng-container *ngFor="let a of actions">
    <button *ngIf="!a.confirm; else confirmBtn"
            type="button"
            class="app-actions__btn"
            [class.app-actions__btn--primary]="a.style === 'primary'"
            [class.app-actions__btn--outline]="a.style === 'outline'"
            [class.app-actions__btn--danger]="a.style === 'danger'"
            [class.app-actions__btn--ghost]="(a.style || 'ghost') === 'ghost'"
            (click)="run(a)">
      <i nz-icon [nzType]="a.icon" nzTheme="outline"></i>
      <span>{{ a.label }}</span>
    </button>
    <ng-template #confirmBtn>
      <button type="button"
              class="app-actions__btn"
              [class.app-actions__btn--primary]="a.style === 'primary'"
              [class.app-actions__btn--outline]="a.style === 'outline'"
              [class.app-actions__btn--danger]="a.style === 'danger'"
              [class.app-actions__btn--ghost]="(a.style || 'ghost') === 'ghost'"
              nz-popconfirm
              [nzPopconfirmTitle]="a.confirm || ''"
              (nzOnConfirm)="run(a)">
        <i nz-icon [nzType]="a.icon" nzTheme="outline"></i>
        <span>{{ a.label }}</span>
      </button>
    </ng-template>
  </ng-container>
</div>
